export default __webpack_public_path__ + "static/media/naruto.71070f03.png";